/* js/components/CheckedIcon.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	init,
	insert,
	noop,
	safe_not_equal,
	set_style,
	svg_element
} from "svelte/internal";

function create_fragment(ctx) {
	let svg;
	let path;

	return {
		c() {
			svg = svg_element("svg");
			path = svg_element("path");
			attr(path, "d", "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0");
			attr(path, "fill", "#fff");
			attr(path, "fillrule", "evenodd");
			attr(svg, "height", "100%");
			attr(svg, "width", "100%");
			attr(svg, "viewBox", "-2 -5 17 21");
			set_style(svg, "position", "absolute");
			set_style(svg, "top", "0");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class CheckedIcon extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default CheckedIcon;